
import { defineComponent, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
        checkbox: Checkbox,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            name: undefined as string | undefined,
            isActive: 0 as number,
        })

        const reset = () => {
            state.name = undefined
            state.isActive = 0

            emit('reset')
        }

        const search = () => {
            emit('search', {
                name: state.name,
                isActive: state.isActive,
            })
        }

        return {
            state,
            reset,
            search,
        }
    },
})
